import React, { Dispatch, SetStateAction } from 'react';
import css from './animal-events-list.module.css';
import Toolbar from './components/toolbar';
import Calendar from './components/calendar/Calendar';
import { AnimalEvent } from '../../../../interfaces/animal-event';
interface Props {
  data: AnimalEvent[];
  missedCount: number;
  plannedCount: number;
  completedCount: number;
  noticesCount: number;
  useCalendarView: boolean;
  setUseCalendarView: Dispatch<SetStateAction<boolean>>;
  furthestYear: number;
}

export default function AnimalEventsList({
  data,
  missedCount,
  plannedCount,
  completedCount,
  noticesCount,
  useCalendarView,
  setUseCalendarView,
  furthestYear,
}: Props) {
  return (
    <div className={css['body']}>
      <Toolbar
        missedCount={missedCount}
        plannedCount={plannedCount}
        completedCount={completedCount}
        noticesCount={noticesCount}
        useCalendarView={useCalendarView}
        setUseCalendarView={setUseCalendarView}
      />
      <Calendar data={data} furthestYear={furthestYear} />
    </div>
  );
}
